import React from 'react';
import './CustomNavPanel.css';

export interface itemsProps {
    name: string;
    icon: string;
    hidden?: boolean;
    CustomOnclick?: Function;
}
interface CustomNavPanelProps {
    defaultClickCard: string
    items: itemsProps[];
    onItemClick: Function;
}
export const CustomNavPanel: React.FC<CustomNavPanelProps> = (props) => {
    const handleClick = (item) => {
        item.CustomOnclick ? item.CustomOnclick() : props.onItemClick(item)
    }
    return (
        <div className="sidebar">
            {props.items.map((item, index) => (
                <>
                {
                    !item.hidden &&
                    <div 
                    key={index} 
                    className={`sidebar-item ${props.defaultClickCard === item.name ? 'sidebar-item-clicked' : ''}`} 
                    onClick={() =>handleClick(item)}
                    >
                        {
                            item.icon &&
                            <img src={item.icon} alt={item.name} className="sidebar-icon" />
                        }
                        <span className={item.icon ? "sidebar-text" : "sidebar-text notIcon"}>{item.name}</span>
                    </div>
                }
            </>
            ))}
        </div>
    );
}
